export const CREATE_PROPOSAL_STATUS_MUTATION = `
  mutation CreateProposalStatus($object: proposal_status_insert_input!) {
    insert_proposal_status_one(object: $object) {
      id
      name
      description
      status
      company_id
      created_at
      updated_at
      company {
        id
        name
      }
    }
  }
`;

export const UPDATE_PROPOSAL_STATUS_MUTATION = `
  mutation UpdateProposalStatus($id: Int!, $set: proposal_status_set_input!) {
    update_proposal_status_by_pk(pk_columns: { id: $id }, _set: $set) {
      id
      name
      description
      status
      company_id
      created_at
      updated_at
      company {
        id
        name
      }
    }
  }
`;

export const DELETE_PROPOSAL_STATUS_MUTATION = `
  mutation DeleteProposalStatus($id: Int!) {
    delete_proposal_status_by_pk(id: $id) {
      id
    }
  }
`; 